// 汽车行业
import router from '@/router'
import { getPartitioningChild } from '@/utils/api'

export default {
  state: {
    // 车型列表
    carModelList: [],
    // 车辆用途列表
    carPurposeList: [],
    // 车辆动力类型
    carDriveTypeList: [],
  },
  getters: {},
  mutations: {
    // 设置车型列表
    setCarModelList(state, data) {
      state.carModelList = [...data]
    },
    // 设置车辆用途列表
    setCarPurposeList(state, data) {
      state.carPurposeList = [...data]
    },
    // 设置车辆用途列表
    setCarDriveTypeList(state, data) {
      state.carDriveTypeList = [...data]
    },
  },
  actions: {
    // 获取车型列表
    async getCarModelList({ commit }) {
      let [err, res] = await getPartitioningChild(3)
      if (err) return
      // 保存车型列表
      commit('setCarModelList', res)
    },
    // 获取车辆用途列表
    async getCarPurposeList({ commit }) {
      let [err, res] = await getPartitioningChild(4)
      if (err) return
      // 保存车辆用途列表
      commit('setCarPurposeList', res)
    },
    // 获取车辆用途列表
    async getCarDriveTypeList({ commit }) {
      let [err, res] = await getPartitioningChild(17)
      if (err) return
      // 保存车辆用途列表
      commit('setCarDriveTypeList', res)
    },
  }
}
